var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-white px-2 py-1 rounded text-xs tracking-wider",class:_vm.isRecipe ? 'bg-red-400' :  _vm.isFaq ? 'bg-green-400' :'bg-gray-700'},[_vm._v(" "+_vm._s(_vm.getLabelByType)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }